import { MatchViewModel } from '../../backend/entryPoints/mapper/mapToMatchViewModel';
import { checkMatchWinCondition } from '../game/game';

export const calculateStanding = (matchViewModels: MatchViewModel[]) => {
    let home = 0;
    let guest = 0;
    matchViewModels.forEach((match) => {
        const { winner } = checkMatchWinCondition(
            match.games.map((g) => ({
                homePoints: g.home_points,
                guestPoints: g.guest_points,
            }))
        );
        if (winner === 0) home += 1;
        if (winner === 1) guest += 1;
    });
    return [home, guest];
};
